export const TIDE_TOKEN_KEY = "id_token";
export const AKVA_TOKEN_KEY = "token";
export const REFRESH_TOKEN_KEY = "refresh_token";

export function clearSyncedTokens(): void {
  try {
    localStorage.removeItem(TIDE_TOKEN_KEY);
    localStorage.removeItem(AKVA_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  } catch {
    /* localStorage unavailable */
  }
}
